import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';
import { AiService } from '../api/agentStep.model';
import { getAiServiceLogoPath, getAiServiceDisplayName } from 'src/app/common/aiServiceUtils';

export const AiServiceSelectOptions: ISelectOption[] = [
  {
    id: AiService.m365Copilot,
    value: AiService.m365Copilot,
    displayName: AiService.m365Copilot,
    filterType: FilterTypesEnum.AiService,
    categoryName: FilterTypesEnum.AiService.toString(),
    iconPath: getAiServiceLogoPath(AiService.m365Copilot),
  },
  {
    id: AiService.copilotStudio,
    value: AiService.copilotStudio,
    displayName: AiService.copilotStudio,
    filterType: FilterTypesEnum.AiService,
    categoryName: FilterTypesEnum.AiService.toString(),
    iconPath: getAiServiceLogoPath(AiService.copilotStudio),
  },
  {
    id: AiService.chatGptEnterprise,
    value: AiService.chatGptEnterprise,
    displayName: AiService.chatGptEnterprise,
    filterType: FilterTypesEnum.AiService,
    categoryName: FilterTypesEnum.AiService.toString(),
    iconPath: getAiServiceLogoPath(AiService.chatGptEnterprise),
  },
  {
    id: AiService.azureAiFoundry,
    value: AiService.azureAiFoundry,
    displayName: AiService.azureAiFoundry,
    filterType: FilterTypesEnum.AiService,
    categoryName: FilterTypesEnum.AiService.toString(),
    iconPath: getAiServiceLogoPath(AiService.azureAiFoundry),
  },
  {
    id: AiService.vertexAi,
    value: AiService.vertexAi,
    displayName: AiService.vertexAi,
    filterType: FilterTypesEnum.AiService,
    categoryName: FilterTypesEnum.AiService.toString(),
    iconPath: getAiServiceLogoPath(AiService.vertexAi),
  },
];
